<ng-container *ngIf="filterFormLoaded; else skeleton">
  <form
    [formGroup]="filterFormGroup"
    class="mobile-filters"
  >
    <filter-select
      formControlName="concerns"
      placeholder="My concerns"
      [multiple]="true"
      [hasTopSelection]="true"
      [compareOptions]="compareConcerns"
      [categorizedOptions]="concernOptions"
    ></filter-select>
    <more-filters
      [filterFormGroup]="filterFormGroup"
      [insuranceOptions]="insuranceOptions"
      [genderOptions]="genderOptions"
      [locationOptions]="stateOptions"
      (moreFiltersSelections)="handleMoreFilterChange($event)"
    ></more-filters>
  </form>
  <form
    [formGroup]="filterFormGroup"
    class="desktop-filters"
  >
    <filter-select
      formControlName="state"
      placeholder="My location"
      [categorizedOptions]="stateOptions"
      [compareOptions]="compareSimpleTypes"
      data-test="location"
    ></filter-select>
    <filter-select
      formControlName="concerns"
      placeholder="My concerns"
      [multiple]="true"
      [multicolumn]="true"
      [hasTopSelection]="true"
      [categorizedOptions]="concernOptions"
      [compareOptions]="compareConcerns"
      data-test="concerns"
    ></filter-select>
    <filter-select
      formControlName="insurance"
      placeholder="My insurance"
      [categorizedOptions]="insuranceOptions"
      [compareOptions]="compareInsurances"
      [clearSelectedOptions]="clearSelectedFormOptions"
      data-test="my-insurance"
    ></filter-select>
    <filter-select
      formControlName="genders"
      placeholder="Gender preference"
      [multiple]="true"
      [categorizedOptions]="genderOptions"
      data-test="genders"
    ></filter-select>
  </form>
</ng-container>

<ng-template #skeleton>
  <div class="skeleton-filters mobile-filters">
    <div class="skeleton-filter-select shimmer"><span>My concerns</span></div>
    <div class="skeleton-more-filters shimmer"><span>More filters</span></div>
  </div>
  <div class="skeleton-filters desktop-filters">
    <div class="skeleton-filter-select shimmer"><span>My location</span></div>
    <div class="skeleton-filter-select shimmer"><span>My concerns</span></div>
    <div class="skeleton-filter-select shimmer"><span>My insurance</span></div>
    <div class="skeleton-filter-select shimmer"><span>Gender preference</span></div>
  </div>
</ng-template>
